export function decodeValue(value: string | null) {
  if (!value) return "";
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function extractPriceFromEventName(eventTypeName = "") {
  const clean = eventTypeName.replace(/\s+/g, " ");
  const priceMatch = clean.match(/Үнэ\s*:\s*([\d,]+)/i);
  if (priceMatch?.[1]) return Number(priceMatch[1].replace(/,/g, ""));
  const fallbackMatch = clean.match(/(\d[\d,]{3,})/);
  if (fallbackMatch?.[1]) return Number(fallbackMatch[1].replace(/,/g, ""));
  return 0;
}

export function formatPrice(amount = 0) {
  return amount.toLocaleString("en-US");
}
